import _, { filter, isEmpty, isNil, reduce, sumBy, trim } from "lodash";
import { useMemo } from "react";
import { HandlingType, Terminal } from "../types/graph";

type TerminalHazardClassSummaryProps = {
    terminal?: Terminal,
    separateTeus?: boolean
};

const useTerminalHazardClassSummary = (props: TerminalHazardClassSummaryProps) => {

    //const { t } = useTranslation('common');
    const { terminal } = props;
    const handlings = terminal?.handlings ?? [];

    const counters = useMemo(() => _(reduce(handlings, (counters, { dangerousGoods, checkedIn, checkedOut, loadingUnitSize, loadingUnitSizeFromGate, type }) => {
        if (checkedOut === true || type === HandlingType.Transit || type === HandlingType.None) {
            return counters;
        }

        const size = Number(loadingUnitSizeFromGate?.[0] ?? loadingUnitSize?.[0] ?? 4)


        const teus = (isNaN(size) ? 4 : size) / 2;

        const teusIndex = Math.ceil(teus);

        if (teusIndex === 0) {
            return counters;
        }

        const dgWithClass = filter(dangerousGoods, ({ adrClass }) => !isNil(adrClass) && !isEmpty(trim(adrClass)));

        if (dgWithClass.length === 0) {
            return counters;
        }

        const { adrClass } = _(dgWithClass)
            .groupBy('adrClass')
            .map((gr, cl) => ({ adrClass: cl, weight: sumBy(gr, (dg) => dg.weight ?? 0) }))
            .maxBy('weight') as { adrClass: string, weight: number }

        counters[adrClass] ??= {
            inYard: [0, 0, 0],
            expected: [0, 0, 0],
            total: [0, 0, 0]
        };

        counters[adrClass][checkedIn ? 'inYard' : 'expected'][0] += teus;
        counters[adrClass][checkedIn ? 'inYard' : 'expected'][teusIndex] += 1;

        counters[adrClass].total[0] += teus;
        counters[adrClass].total[teusIndex] += 1;

        return counters;

    }, {} as Record<string, {
        inYard: [number, number, number],
        expected: [number, number, number],
        total: [number, number, number]
    }>)).toPairs().sortBy(0).fromPairs().value(), [handlings]);

    return counters;
}

export default useTerminalHazardClassSummary;